<template>
  <div class="returns-portal container">
    <iframe
      id="returnscenter"
      class="iframe"
      :src="returnsPortalUrl"
      title="shopper"
      width="100%"
    >
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ReturnsPortal",
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    returnsPortalUrl() {
      return "https://returns.ratandboa.com?mode=compat";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/helpers";

.iframe {
  height: 80vh;
}
</style>
